import mapNewsletterItems from '../functions/mapNewsletterItems'
import NewsletterContentText from './NewsletterContentText'
import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import { textNormal } from './helpersTypo'

const NewsletterSectionText = ({id, stylesData, newsletterData, items}) => {
    const chosenFont = stylesData.chosenFont
    const colorText = stylesData.mainText

    const components = []

    return (
        mapNewsletterItems(id, newsletterData, items, (components, itemData, index) => {
            const { text } = itemData
            
            components.push(
                <NewsletterSectionRow key={index + '-text'}>
                    <TableWrapper>
                        <tr>
                            <NewsletterContentText style={{...textNormal(chosenFont), ...{color: colorText, textAlign: "center", paddingTop: "50px", paddingBottom: "11px"}}}>
                                <section dangerouslySetInnerHTML={{ __html: text}}></section>
                            </NewsletterContentText>
                        </tr>
                    </TableWrapper>
                </NewsletterSectionRow>
            )
        }, components)
    )
}

export default NewsletterSectionText

